module.exports = __webpack_public_path__ + "img/image-gran-espresso.e3b86507.png";